import { UnitOfMeasureBase } from './base/unit-of-measure-base';

export class UnitOfMeasure extends UnitOfMeasureBase { }